import React from 'react';
import MessageTemple from '../../../../../../libs/api/services/MessageTemple';
import './RTESuggestions.css';
export default class Suggestions extends React.Component {
    constructor() {
        super()
        this.state = {
            categories: []
        }
    }

    // useEffect(() => {
    //     const handleKeyDown = (e) => {
    //          const key = e.key;
    //          setGrid((state) => {
    //              let { row, col } = result;

    //              // make new array pointers
    //              const grid = [ …state.grid ];
    //              grid[row] = [ …grid[row] ];
    //              grid[row][col] = key;

    //              // i think you would do this before setting the grid??
    //              if (col > grid[0].length) {
    //                  row++;
    //                  col = 0;
    //              } else {
    //                  col++;
    //              }

    //              return {
    //                   …state,
    //                   grid,
    //                   col,
    //                   row
    //               };
    //          });

    //     };
    //     document.addEventListener('keydown', handleKeyDown, true);

    //     return () => {
    //         document.removeEventListener('keydown', handleKeyDown);
    //     };

    // }, [setGrid]);

    componentDidMount = () => {
        MessageTemple
            .ListVariableCategories()
            .then((r) => {
                // this.setState({ categories: r })
                var _orderedItems = []
                var _categories = []
                var _sorted = []
                for (const cat of r) {
                    for (const _field of cat.fields) {
                        _sorted.push(_field.fieldClass + "." + _field.fieldName)
                    }
                }
                this.setState({ categories: _sorted })
            })
    }

    _filterResult(results, search) {
        var reslts = []
        const srch_spl = search.split(/[^A-Za-z]/)
        var _found = false
        for (const res of results) {
            for (const srch of srch_spl) {
                if (res.toLowerCase().indexOf(srch.toLowerCase()) > -1) {
                    _found = true
                    break;
                }
            }
            if (_found) {
                reslts.push(res)
                _found = false
                // break;
            }
        }

        if (search)
            if (reslts.length === 0)
                return results
            else
                return reslts
        return []
    }
    render() {
        const { autocompleteState } = this.props;
        if (!autocompleteState || !autocompleteState.searchText) return null;
        const { searchText } = autocompleteState;
        return (
            // <ul className='suggestions-list'>
            //     {this.listItem}
            // </ul>
            <div className='suggestions'>
                <ul className='suggestions-list'>
                    {
                        // [
                        //     "Jaervinen",
                        //     "Nieminen",
                        //     "Lamminpaeae",
                        //     "Kallio",
                        //     "Jokinen",
                        //     "Niittukari",
                        //     "Li"
                        // ]
                        this._filterResult(this.state.categories, searchText)
                            // .filter(item => item.substring(0, searchText.length) === searchText)
                            .map(result => {
                                const select = () => this.props.renderSuggestion(result);
                                return <li onMouseDown={select}>{result}</li>
                            })
                    }
                </ul>
            </div>
        )
    }
}